<template>
  <draggable-modal ref="modal" :width="600" :height="320" :autoMinHeight="true" :minWidth="400" @modalDismissed="setSelectedNodeID(null)">
    <v-card-title>
      <span class="headline">Edit Box</span>
      <v-spacer />
      <v-btn
        text
        class="ma-0 pa-0"
        @click="setSelectedNodeID(null)"
      >
        <v-icon x-large color="red">mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>

          <v-col cols="12">
            <v-text-field
              color="orange"
              v-model="text"
              label="Box's Title"
              outlined />
          </v-col>

          <v-expansion-panels>
            <v-expansion-panel @change="delay(resizeModal, 300)"> <!-- This delay makes sure tthe animation is done first -->
              <v-expansion-panel-header>
                Extra Settings
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-col cols="12">
                  <v-select
                    color="orange"
                    readonly
                    v-model="pinnedBy"
                    :items="pinnedBy"
                    chips
                    multiple
                    label="Dotted By"
                    placeholder="No one has dotted this yet"
                  >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      @click="data.select"
                    >
                      <v-avatar :color="data.item.avatar.color" left>
                        <span class="white--text">{{ data.item.avatar.initials }}</span>
                      </v-avatar>
                      {{ data.item.name }}
                    </v-chip>
                  </template>
                  <v-icon slot="append" color="green"></v-icon>
                  </v-select>
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="color"
                    :items="colorDropdownOptions"
                    color="orange"
                    item-color="orange"
                    label="Color"
                  />
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="font"
                    :items="fontDropdownOptions"
                    color="orange"
                    item-color="orange"
                    label="Font"
                  />
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="fontColor"
                    :items="fontColorDropdownOptions"
                    color="orange"
                    item-color="orange"
                    label="Font Color"
                  />
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="dotColor"
                    :items="dotColorDropdownOptions"
                    color="orange"
                    item-color="orange"
                    label="Dot Color"
                  />
                </v-col>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="orange"
        text
        @click="setSelectedNodeID(null)"
      >
        Cancel
      </v-btn>
      <v-btn
        color="orange"
        text
        @click="onDelete()"
      >
        Delete
      </v-btn>
      <v-btn
        color="orange"
        text
        @click="onSubmit()"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </draggable-modal>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import canvasConstants from '@/store/modules/canvas/canvasConstants'
import DraggableModal from './DragableModal.vue'

export default {
  name: 'NodeModal',
  data () {
    return {
      text: null,
      color: null,
      font: null,
      fontColor: null,
      dotColor: null,
      pinnedBy: []
    }
  },
  components: {
    DraggableModal
  },

  mounted () {

  },

  watch: {
    async selectedNodeID () {
      console.log('selectedNode changed')
      if (this.selectedNodeID !== null) {
        this.$refs.modal.show()
      } else {
        this.$refs.modal.hide()
      }
      console.log(this.selectedNode)

      if (this.selectedNodeID !== null) {
        this.text = this.selectedNode.text

        console.log(this.selectedNode)
        this.pinnedBy = []
        for (var u of this.selectedNode.pinned) {
          var user = await this.requestSearchUserByUUID(u)
          this.pinnedBy.push(user)
        }
        console.log(this.pinnedBy)

        this.color = `Current Color (${this.selectedNode.fill})`
        this.colors.forEach(c => {
          if (this.selectedNode.fill === c.code) {
            this.color = c.label
          }
        })

        this.font = this.fonts[0].label
        this.fonts.forEach(f => {
          if (this.selectedNode.font === f.value) {
            this.font = f.label
          }
        })

        this.fontColor = `Current Color (${this.selectedNode.fontColor})`
        this.fontColors.forEach(f => {
          if (this.selectedNode.fontColor === f.code) {
            this.fontColor = f.label
          }
        })
        this.dotColor = `Current Color (${this.selectedNode.dotColor})`
        this.dotColors.forEach(f => {
          if (this.selectedNode.dotColor === f.code) {
            this.dotColor = f.label
          }
        })
      }
    }
  },
  computed: {
    ...mapState('canvas', ['selectedNodeID', 'nodeMap']),
    colors () {
      return this.$store.state.challenge.currentlyViewedChallenge.nodeColors
    },
    fonts () {
      return canvasConstants.nodeFonts
    },
    fontColors () {
      return this.$store.state.challenge.currentlyViewedChallenge.fontColors
    },
    dotColors () {
      return this.$store.state.challenge.currentlyViewedChallenge.dotColors
    },
    selectedNode () {
      return (this.selectedNodeID === null) ? {
        text: '',
        fill: '',
        font: '',
        fontColor: '',
        dotColor: ''
      } : this.nodeMap[this.selectedNodeID]
    },
    colorDropdownOptions () {
      const result = []
      this.colors.forEach(c => {
        result.push(c.label)
      })

      let hasColor = false
      this.colors.forEach(c => {
        if (this.selectedNode.fill === c.code) {
          hasColor = true
        }
      })

      if (!hasColor) {
        result.push(`Current Color (${this.selectedNode.fill})`)
      }

      return result
    },
    fontDropdownOptions () {
      const result = []
      this.fonts.forEach(c => {
        result.push(c.label)
      })
      return result
    },
    fontColorDropdownOptions () {
      const result = []
      this.fontColors.forEach(c => {
        result.push(c.label)
      })

      let hasColor = false
      this.fontColors.forEach(c => {
        if (this.selectedNode.fontColor === c.code) {
          hasColor = true
        }
      })

      if (!hasColor) {
        result.push(`Current Color (${this.selectedNode.fontColor})`)
      }

      return result
    },
    dotColorDropdownOptions () {
      const result = []
      this.dotColors.forEach(c => {
        result.push(c.label)
      })

      let hasColor = false
      this.dotColors.forEach(c => {
        if (this.selectedNode.dotColor === c.code) {
          hasColor = true
        }
      })

      if (!hasColor) {
        result.push(`Current Color (${this.selectedNode.dotColor})`)
      }

      return result
    }
  },
  methods: {
    ...mapMutations('canvas', ['setSelectedNodeID']),
    ...mapActions('canvas', [
      'changeNodeText', 'changeNodeFill', 'changeNodeFont',
      'changeNodeFontColor', 'deleteNode', 'changeNodeDotColor'
    ]),
    ...mapActions(['requestSearchUserByUUID', 'getAvatarFromUserName']),
    onSubmit () {
      let fill = this.selectedNode.fill
      this.colors.forEach(c => {
        if (this.color === c.label) {
          fill = c.code
        }
      })

      let fontVal = this.fonts[0].value
      this.fonts.forEach(f => {
        if (this.font === f.label) {
          fontVal = f.value
        }
      })

      let fontColorVal = this.selectedNode.fontColor
      this.fontColors.forEach(f => {
        if (this.fontColor === f.label) {
          fontColorVal = f.code
        }
      })

      let dotColorVal = this.selectedNode.dotColor
      this.dotColors.forEach(f => {
        if (this.dotColor === f.label) {
          dotColorVal = f.code
        }
      })

      let nodeText = this.text.trim()
      if (!nodeText.endsWith('?')) {
        nodeText += '?'
      }
      this.changeNodeText({
        nodeID: this.selectedNodeID,
        newText: nodeText
      })
      this.changeNodeFill({
        nodeID: this.selectedNodeID,
        newFill: fill
      })
      this.changeNodeFont({
        nodeID: this.selectedNodeID,
        newFont: fontVal
      })
      this.changeNodeFontColor({
        nodeID: this.selectedNodeID,
        newFontColor: fontColorVal
      })
      this.changeNodeDotColor({
        nodeID: this.selectedNodeID,
        newDotColor: dotColorVal
      })

      this.setSelectedNodeID(null)
    },
    onDelete () {
      this.deleteNode({
        nodeID: this.selectedNodeID
      })
      this.setSelectedNodeID(null)
    },
    resizeModal () {
      this.$refs.modal.recalculateSize()
    },
    async delay (func, ms) {
      return new Promise(() => setTimeout(func, ms))
    }
  }
}
</script>
